import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';

interface ISystemService {
  getSystemHealth: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<string>>;
  getSystemReadiness: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<string>>;
}

export const systemService: ISystemService = {
  getSystemHealth(axiosConfig) {
    return ajax.get<string>(`${config.merchantsApiUrl}/health`, axiosConfig);
  },
  getSystemReadiness(axiosConfig) {
    return ajax.get<string>(
      `${config.merchantsApiUrl}/health/ready`,
      axiosConfig,
    );
  },
};
